"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionInsightProcessModal = void 0;
var tslib_1 = require("tslib");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var collection_insight_process_modal_ctrl_1 = require("./collection.insight.process.modal.ctrl");
var collection_insight_process_modal_style_1 = require("./collection.insight.process.modal.style");
(0, theme_1.addStyles)(collection_insight_process_modal_style_1.Style);
var CollectionInsightProcessModal = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionInsightProcessModal, _super);
    function CollectionInsightProcessModal(ctx, collections) {
        var _this = _super.call(this, ctx) || this;
        _this.ctrl = new collection_insight_process_modal_ctrl_1.CollectionInsightProcessModalCtrl(collections);
        return _this;
    }
    Object.defineProperty(CollectionInsightProcessModal.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('div', { className: collection_insight_process_modal_style_1.CSS.container }, [
                (0, mithril_1.m)('div', { className: collection_insight_process_modal_style_1.CSS.content }, [
                    (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_INSIGHT_PROCESS_CONFIRM, this.ctrl.collections.length))
                ])
            ]);
        },
        enumerable: false,
        configurable: true
    });
    CollectionInsightProcessModal.prototype.submit = function () {
        return this.ctrl.insightProcessCollections();
    };
    return CollectionInsightProcessModal;
}(modal_form_component_1.ModalFormComponent));
exports.CollectionInsightProcessModal = CollectionInsightProcessModal;
//# sourceMappingURL=collection.insight.process.modal.js.map